const mapProduct = (p) => {
  return {
    id: p.id,
    title: p.name,
    price: p.isDiscount ? `${p.costDiscount} ₽` : `${p.cost} ₽`,
    originalPrice: `${p.cost} ₽`,
    hasDiscount: p.isDiscount,
    rating: p.rating?.toString() ?? "0",
    reviews: p.reviewCount?.toString() ?? "0",
    hasBadge: p.isDiscount,
    badgeType: p.isDiscount ? "Акция" : undefined,
    bonus: p.bonus,
    isFavorite: p.isFavorite,
    photos: p.photos,
    photo: p.photo
  };
};

export default mapProduct;